export const AbortReason = {
  replaced: 'REPLACED',
  unmounted: 'UNMOUNTED'
};
